<template>
    <div id="app">
        <common-header
            :headerInput="headerInput"
            focus="ETL"
            :mobile="true"
        ></common-header>
        <router-view />
        <back-to-top>
            <template #img>
                <img :src="require('../src/assets/footer-down.png')" />
            </template>
        </back-to-top>
        <common-footer></common-footer>
    </div>
</template>

<script>
import {BackToTop } from "eco-page-component";
import FeedBack from "./FeedBack.vue";
import { CommonHeader, HeaderInput, CommonFooter } from "eco-components-header";
import DownLoadPage from "./views/Home";
import {user,service,ws,router, env} from 'eco-cli'
import 'eco-components-header/lib/EcoComponentsHeader.css'

export default {
    components: {
        CommonHeader,
        CommonFooter,
        BackToTop,
        DownLoadPage,
        FeedBack
    },
    data() {
        return { headerInput: null, config: env.config() };
    },
    async beforeCreate(){
        const permission = await user.getPermissions()
        if(!permission.isKeyOk('client','vip','can-enter-vip-client')){
            user.login()
        }
    },
    mounted() {
        HeaderInput.csr({
            user,
            service,
            ws,
            router,
        }).then((v) => {
            this.headerInput = v;
        });
        window.downloadFinance = this.downloadFinance;
    },
    destroyed() {
        window.downloadFinance = null;
    },
    methods: {
        downloadFinance(downloadId) {
            getAttachDownkey(downloadId).then((res) => {
                const href = this.config.file_origin + "/eco-file-server/file/eco/auth/download/" + res;
                window.open(href, "_self");
            });
        }
    },
};
</script>

<style scoped>
@import url("https://download.dameng.com/eco/eco-lib-public/style/base.css");


</style>

<style>

#app .eco-common-header a:hover {
    color: #fff;
}

#app .eco-common-header a:active:hover {
    color: #fff;
}

#app a:active:hover,#app a:hover {
    color: var(--action-color);
}
.ant-tabs-ink-bar{
    background-color: var(--action-color)!important;
}
.ant-input-clear-icon{
    transition: all 0.3s ease;
    color: #F0CD89!important;
    font-size: 16px!important;
    opacity: 0.5;
}

.ant-input-clear-icon:hover{
    opacity: 1;
}
.ant-input,.ant-btn-lg{
    border-radius: 0!important;
}
.ant-btn:hover, .ant-btn:focus{
    color: var(--action-color)!important;
    border-color: var(--action-color)!important;
}
.ant-dropdown-menu {
    border-radius: 0!important;
}
.ant-dropdown-menu-item:hover, .ant-dropdown-menu-submenu-title:hover{
    background-color: var(--action-color-light)!important;
}
.ant-input-group-addon{
    position: relative;
}
.ant-input-group-addon::after{
    transition: all 0.3s ease;
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    background: #fff;
    opacity: 0;
}

.ant-input-group-addon:hover::after{
    opacity: 0.12;
}
</style>
